import React,{useEffect,useRef} from "react";
import "./toast.scss";
import { ErrorInfoIcon } from "../../../assets/Icons";

interface ToastProps {
  isVisible: boolean;
  message: string;
  /** 
   * If provided, "Retry" button will be shown. 
   * When clicked, onRetry() is invoked.
   */
  onRetry?: () => void;
  /** Closes the toast. */
  onClose: () => void;
  /** Toast variant for different styling */
  variant?: 'error' | 'primary';
}

const Toast: React.FC<ToastProps> = ({ isVisible, message, onRetry, onClose, variant = 'error' }) => {
    const toastRef = useRef<HTMLDivElement>(null);
 // Hide toast if user clicks/taps outside of the toast container
 useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (toastRef.current && !toastRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className={`toast-container toast-${variant}`} ref={toastRef}>
      <div className="toast-content">
          <ErrorInfoIcon/>
        <div>
        <p className="toast-message" style={{ whiteSpace: 'pre-line' }}>{message}</p>
        {variant === 'error' && <p className="toast-try-again">Please try again</p>}
        </div>
        {onRetry && (
          <button
          className="toast-retry-button"
          onClick={() => {
            onRetry();
            onClose(); // Hide toast after Retry
          }}
        >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default Toast;
